export default {
  name: {
    type_id: "類型",
  },
  type: {
    1: "五金",
    2: "物料",
  },
};
